import { SELECT_ACTION_ADD, SELECT_ACTION_REMOVE } from 'constants/index'
import React from 'react'
import { Tooltip } from '@material-ui/core'
import cn from 'classnames'
import { onSelectMenuOption } from 'helpers/common'
import { PURPLE } from 'constants/colors'
import Checkbox from 'components/common/Checkbox'
import { AssigneeImageInList } from '../UsersList/UsersList.styles'
import AvatarPlaceholder from '../AvatarPlaceholder/AvatarPlaceholder'
import { UsersSelectListProps } from './UsersSelectList.types'
import { UserListItem, ListElement } from './UsersSelectList.styles'

const UsersSelectList = ({
  list,
  tmpUsersArr,
  setTmpUsersArr,
  extraAction,
  assigneeType,
  className,
}: UsersSelectListProps) => (
  <UserListItem
    className={cn({
      [className || '']: className,
    })}>
    {list.map(item => {
      const { id, name } = item
      const isSelected = !!tmpUsersArr.find(
        ({ id: selectedId }) => selectedId === id,
      )

      return (
        <ListElement
          align="center"
          role="button"
          tabIndex={0}
          key={id}
          onClick={() => {
            onSelectMenuOption(
              item,
              { id },
              isSelected,
              tmpUsersArr,
              setTmpUsersArr,
            )

            if (extraAction) {
              extraAction(
                item,
                assigneeType,
                isSelected ? SELECT_ACTION_REMOVE : SELECT_ACTION_ADD,
              )
            }
          }}>
          <Checkbox checked={isSelected} color={PURPLE} />
          <AssigneeImageInList key={id}>
            <Tooltip title={name}>
              {'avatar' in item && item.avatar ? (
                <img src={item.avatar} alt={name} />
              ) : (
                <span>
                  <AvatarPlaceholder userName={name} />
                </span>
              )}
            </Tooltip>
          </AssigneeImageInList>
          {name}
        </ListElement>
      )
    })}
  </UserListItem>
)

export default UsersSelectList
